'use strict';

var DataExtractScheduledTransformerFactory = function DataExtractScheduledTransformerFactory(DataTransformer, momentService, UserProcessingTransformationService) {
  function DataExtractScheduledTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'scheduled-mode';
    this.targetType = 'data-extract-scheduled';
    this.priority = 1;
  }
  DataExtractScheduledTransformer.prototype = Object.create(DataTransformer.prototype);
  DataExtractScheduledTransformer.constructor = DataExtractScheduledTransformer;
  DataExtractScheduledTransformer.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  DataExtractScheduledTransformer.prototype.isCacheable = function () {
    return false;
  };
  DataExtractScheduledTransformer.prototype.getCacheKey = function () {
    return this.sourceType + '-' + this.targetType;
  };
  DataExtractScheduledTransformer.prototype.transform = function (data) {
    if (data.domain.code === 500) {
      return undefined;
    }
    var length = data.domain.length;
    for (var i = 0; i < length; i++) {
      var entry = data.domain[i];
      entry.extractName = entry.exportConfig.extractName;
      entry.description = entry.exportConfig.description;
      entry.createdAt = momentService.of(entry.createdAt, momentService.FIELD.CREATED_AT);
      entry.lastUpdatedAt = momentService.of(entry.lastUpdatedAt, momentService.FIELD.LAST_UPDATED_AT);
      entry.createdBy = UserProcessingTransformationService.getUserDisplayName(entry.createdBy);
      entry.lastUpdatedBy = UserProcessingTransformationService.getUserDisplayName(entry.lastUpdatedBy);
    }
    return data.domain;
  };
  return DataExtractScheduledTransformer;
};
DataExtractScheduledTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService', 'UserProcessingTransformationService'];
module.exports = DataExtractScheduledTransformerFactory;